
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34783',
  depVersions: {
  "documents-public-ui": "static-1.34783",
  "atom": "static-1.5187",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2609",
  "client-types": "static-1.479",
  "cssUtils": "static-1.823",
  "customer-data-filters-ui": "static-1.40184",
  "customer-data-objects": "static-1.7791",
  "customer-data-property-utils": "static-1.8207",
  "documents-lib": "static-1.34788",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.345",
  "FormsCommonComponents": "static-1.86118",
  "FormUrlGenerator": "static-2.4833",
  "foundations-theming-specialty": "static-1.2258",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5703",
  "hs-test-utils": "static-1.8133",
  "hub-http": "static-1.6334",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11895",
  "HubStyleTokens": "static-2.11588",
  "I18n": "static-7.1637",
  "icons": "static-2.653",
  "jasmine-immutable": "static-1.3133",
  "jasmine-runner": "static-1.6570",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7265",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5508",
  "quartz": "static-1.7170",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16796",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5423",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8286",
  "reference-resolvers-lite": "static-1.8210",
  "reporting-data": "static-1.68025",
  "reporting-reports": "static-1.67703",
  "reporting-snowflake": "static-1.56643",
  "reporting-testing-lib": "static-1.9958",
  "reporting-visualizations": "static-1.60101",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9058",
  "sanitize": "static-1.4587",
  "sanitize-text": "static-1.8257",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1857",
  "signup-constants": "static-1.19112",
  "signup-ui-url-generator": "static-2.8170",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4871",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4871",
  "ui-addon-form-validation": "static-1.11101",
  "ui-asset-management-lib": "static-1.11175",
  "ui-images": "static-2.1180",
  "UIComponents": "static-3.8534",
  "usage-tracker": "static-1.7460",
  "usage-tracker-container": "static-1.7450",
  "usage-tracker-core": "static-1.7310",
  "viral-links-lib": "static-1.7181",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9774",
  "foundations-components": "static-1.8150",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.948",
  "quartz-core": "static-1.6389",
  "quick-fetch": "static-1.3999",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4768",
  "ui-addon-i18n": "static-1.11260",
  "ui-addon-upgrades": "static-9.18146",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3479",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3447",
  "quartz-webpack": "static-1.3394",
  "foundations-assets": "static-1.4985",
  "foundations-theming": "static-1.4542",
  "hub-http-shared-msw-handlers": "static-1.10241",
  "hubspotter-http": "static-1.4732",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7359",
  "crm-message-bus": "static-1.43276",
  "customer-data-filters-ui-msw-helpers": "static-1.22619",
  "customer-data-objects-ui-components": "static-1.13142",
  "customer-data-reference-ui-components": "static-1.13285",
  "customer-data-ui-utilities": "static-1.9937",
  "events-data-lib": "static-1.343",
  "framework-builder-read-service-client": "static-1.4086",
  "framework-data-schema-quick-fetch": "static-1.6909",
  "framework-data-schema-resolvers": "static-1.7004",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3668",
  "inbound-db-properties-service-client": "static-1.3926",
  "multi-account-reference-resolvers": "static-1.1094",
  "onboarding-tours": "static-1.16812",
  "reporting-datasets-permissions-lib": "static-1.14004",
  "ui-addon-teams": "static-1.21695",
  "quartz-auth": "static-1.845",
  "ui-business-units-lib": "static-1.9178",
  "usage-tracker-session-replay": "static-1.5146",
  "ai-components-ui-library": "static-1.9239",
  "ContentUtils": "static-1.68687",
  "customer-data-properties": "static-1.51967",
  "forms-ai-lib": "static-1.4493",
  "forms-utils-lib": "static-1.12792",
  "foundations-components-test-utils": "static-1.5633",
  "react-dnd-compat": "static-1.4727",
  "react-tinymce": "static-1.55539",
  "tinymce-config": "static-2.54665",
  "ui-gdpr-components": "static-1.10462",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3527",
  "HeadJS": "static-2.768",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3244",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.163",
  "ui-fonts": "static-1.850",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4437",
  "csstype": "static-1.50",
  "quartz-head": "static-1.835",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1654",
  "external-options-client-types": "static-1.4209",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.845",
  "frontend-preferences-client": "static-1.8039",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3811",
  "reporting-client-types": "static-1.2568",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25711",
  "hubspot-apollo-client": "static-1.4990",
  "foundations-components-legacy": "static-1.1175",
  "quartz-routing": "static-1.600",
  "hs-story-utils": "static-1.9534",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.336",
  "timezone-utils": "static-2.5355",
  "seat-types-lib": "static-1.270",
  "react-create-root-preference": "static-1.35",
  "bend-plugin-foundations-components": "static-1.4419",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2189",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.844",
  "mobile-manifest-mixins": "static-1.543",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.845",
  "quartz-tracking": "static-1.549",
  "trellis-components": "static-1.2208",
  "bend-plugin-chirp-manifest": "static-1.178",
  "chirp-fetch": "static-1.1998",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6085",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4162",
  "bender-build-tools": "static-1.3281",
  "bend-plugin-foundations-theming": "static-1.3025",
  "stylex": "static-1.35",
  "restore-request-side-panel-lib": "static-1.1161",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.284",
  "pulse": "static-1.709",
  "conditional-properties-service-client": "static-1.3877",
  "crm-pipelines-api-client-types": "static-1.4218",
  "fdsr-migration-layer": "static-1.123",
  "multi-currency-client-types": "static-1.3771",
  "getting-started-shared-tasks": "static-1.18725",
  "growth-data-modal": "static-1.5606",
  "growth-onboarding-confetti": "static-1.3177",
  "growth-onboarding-next-action-utils": "static-1.2242",
  "navigation-components": "static-1.18288",
  "onboarding-tours-client": "static-1.5026",
  "onboarding-tours-utils": "static-1.878",
  "ui-shepherd-react": "static-3.10350",
  "ui-shepherd-tracker": "static-1.7731",
  "ui-universal-auth": "static-1.9111",
  "user-context": "static-1.5222",
  "hubspotter-http-shared-msw-handlers": "static-1.10239",
  "magpie-lib": "static-1.5625",
  "navigation-messaging": "static-1.7615",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21831",
  "copilot-toolkit": "static-1.11426",
  "cms-field-types": "static-1.4927",
  "content-icons-ui": "static-1.2257",
  "integrations-lib": "static-1.16512",
  "calling-global-api": "static-1.64900",
  "calling-internal-common": "static-1.31421",
  "calling-lifecycle-internal": "static-1.66282",
  "calling-lifecycle-messages": "static-1.58576",
  "commerce-products-lib": "static-1.9964",
  "crm-links": "static-1.6420",
  "customer-data-properties-shared-msw-handlers": "static-1.9568",
  "file-manager-components": "static-1.23931",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4298",
  "meetings-icalendar-utils-lib": "static-1.745",
  "object-builder-ui-client": "static-1.49133",
  "pipeline-validation-client-types": "static-1.4048",
  "property-value-citations": "static-1.2581",
  "smart-property-lib": "static-1.7788",
  "tiered-pricing": "static-1.1509",
  "ui-addon-iframeable": "static-1.9179",
  "zustand": "static-1.74",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20025",
  "tinymce-themes": "static-1.56635",
  "data-token-picker": "static-1.16604",
  "hub-http-contrib": "static-1.3155",
  "interframe": "static-3.4872",
  "tinymce-data": "static-1.40750",
  "tinymce-plugins": "static-1.57779",
  "ui-addon-sales-email": "static-1.5321",
  "onboarding-scopes": "static-1.6573",
  "ui-addon-opt": "static-4.8473",
  "apollo-link-hub-http": "static-2.4763",
  "hubspot-apollo-cache": "static-1.449",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.285",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1053",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6088",
  "event-emitter": "static-1.1061",
  "bend-plugin-pulse": "static-1.212",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2152",
  "growth-onboarding-next-action-components": "static-1.2270",
  "user-context-client": "static-1.4692",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5085",
  "nest": "static-1.344",
  "reactive-lib": "static-1.837",
  "simple-logging-lib": "static-1.3161",
  "unified-auth-core-lib": "static-1.907",
  "getting-started-shared-tasks-store": "static-1.17843",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1109",
  "integrations-error-boundary-lib": "static-1.13927",
  "integrations-tracking-lib": "static-1.5718",
  "native-integrations-shared-strings": "static-1.7895",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10474",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.625",
  "calling-error-reporting": "static-1.31428",
  "shared-worker-versioning": "static-1.11147",
  "calling-usage-tracker": "static-1.6655",
  "voice-sms-access-library": "static-1.1431",
  "customer-data-tracking": "static-1.7000",
  "commerce-permissions": "static-1.888",
  "products-iframe-lib": "static-1.8242",
  "products-ui-components-shared-msw-handlers": "static-1.10623",
  "location-customization-utils-lib": "static-1.9592",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4262",
  "video-components-external": "static-1.11641",
  "video-data-lib": "static-1.35299",
  "data-agent-kit": "static-1.379",
  "feedback-loader": "static-1.29507",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10324",
  "fsm": "static-1.3840",
  "policy-lib": "static-1.6893",
  "react-colorpicker": "static-2.10319",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10387",
  "FileManagerLib": "static-1.39571",
  "NamespacedHubStyle": "static-2.9136",
  "FileManagerCore": "static-1.39430",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7930",
  "layout-dnd-components": "static-1.12662",
  "layout-dnd-utils": "static-1.11637",
  "react-codemirror": "static-1.10739",
  "ui-addon-emoji-picker": "static-1.9998",
  "ui-brand-identity-lib": "static-1.15685",
  "InboxConnectUtils": "static-4.15107",
  "meetings-connect-utils-lib": "static-1.7717",
  "breeze-engine-core": "static-1.387",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3129",
  "adobe-sign-auth-lib": "static-1.7",
  "ads-unified-auth-lib": "static-1.361",
  "google-sheets-integration-lib": "static-1.570",
  "microsoft-drive-integration-lib": "static-1.701",
  "surveymonkey-integration-lib": "static-1.27",
  "slack-ui-library": "static-1.10506",
  "calling-orchestration-schema": "static-1.36208",
  "sales-views-client-types": "static-1.4368",
  "crm-record-cards-service-types": "static-1.3671",
  "content-media-composition-data-lib": "static-1.12658",
  "content-media-compositions": "static-2.16665",
  "media-bridge-lib": "static-1.19120",
  "trellis-story-utils": "static-1.4624",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6088",
  "FileManagerImages": "static-1.37082",
  "video-components": "static-1.13643",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4647",
  "video-embed": "static-1.36133",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8815",
  "ui-coaching-tips": "static-1.28873",
  "ContentData": "static-1.68762",
  "layout-data-lib": "static-1.9962",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22325",
  "outpost": "static-1.4282",
  "growth-onboarding-feedback-components": "static-1.6691",
  "advanced-menus-core": "static-1.15312",
  "advanced-menus-lib": "static-1.12225",
  "ExportDialog": "static-6.10491",
  "ui-memberships-settings-lib": "static-1.34343",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15311",
  "simple-menus-lib": "static-1.16828"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34783",
  "atom": "/atom/static-1.5187",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2609",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.823",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40184",
  "customer-data-objects": "/customer-data-objects/static-1.7791",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8207",
  "documents-lib": "/documents-lib/static-1.34788",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.345",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86118",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4833",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2258",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5703",
  "hs-test-utils": "/hs-test-utils/static-1.8133",
  "hub-http": "/hub-http/static-1.6334",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11895",
  "HubStyleTokens": "/HubStyleTokens/static-2.11588",
  "I18n": "/I18n/static-7.1637",
  "icons": "/icons/static-2.653",
  "jasmine-immutable": "/jasmine-immutable/static-1.3133",
  "jasmine-runner": "/jasmine-runner/static-1.6570",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7265",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5508",
  "quartz": "/quartz/static-1.7170",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16796",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5423",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8286",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8210",
  "reporting-data": "/reporting-data/static-1.68025",
  "reporting-reports": "/reporting-reports/static-1.67703",
  "reporting-snowflake": "/reporting-snowflake/static-1.56643",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9958",
  "reporting-visualizations": "/reporting-visualizations/static-1.60101",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9058",
  "sanitize": "/sanitize/static-1.4587",
  "sanitize-text": "/sanitize-text/static-1.8257",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1857",
  "signup-constants": "/signup-constants/static-1.19112",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8170",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4871",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4871",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11101",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11175",
  "ui-images": "/ui-images/static-2.1180",
  "UIComponents": "/UIComponents/static-3.8534",
  "usage-tracker": "/usage-tracker/static-1.7460",
  "usage-tracker-container": "/usage-tracker-container/static-1.7450",
  "usage-tracker-core": "/usage-tracker-core/static-1.7310",
  "viral-links-lib": "/viral-links-lib/static-1.7181",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9774",
  "foundations-components": "/foundations-components/static-1.8150",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.948",
  "quartz-core": "/quartz-core/static-1.6389",
  "quick-fetch": "/quick-fetch/static-1.3999",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4768",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11260",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18146",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3479",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3447",
  "quartz-webpack": "/quartz-webpack/static-1.3394",
  "foundations-assets": "/foundations-assets/static-1.4985",
  "foundations-theming": "/foundations-theming/static-1.4542",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10241",
  "hubspotter-http": "/hubspotter-http/static-1.4732",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7359",
  "crm-message-bus": "/crm-message-bus/static-1.43276",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22619",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13142",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13285",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9937",
  "events-data-lib": "/events-data-lib/static-1.343",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4086",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6909",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7004",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3668",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3926",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1094",
  "onboarding-tours": "/onboarding-tours/static-1.16812",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14004",
  "ui-addon-teams": "/ui-addon-teams/static-1.21695",
  "quartz-auth": "/quartz-auth/static-1.845",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9178",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5146",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9239",
  "ContentUtils": "/ContentUtils/static-1.68687",
  "customer-data-properties": "/customer-data-properties/static-1.51967",
  "forms-ai-lib": "/forms-ai-lib/static-1.4493",
  "forms-utils-lib": "/forms-utils-lib/static-1.12792",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5633",
  "react-dnd-compat": "/react-dnd-compat/static-1.4727",
  "react-tinymce": "/react-tinymce/static-1.55539",
  "tinymce-config": "/tinymce-config/static-2.54665",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10462",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3527",
  "HeadJS": "/HeadJS/static-2.768",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3244",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.163",
  "ui-fonts": "/ui-fonts/static-1.850",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4437",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.835",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1654",
  "external-options-client-types": "/external-options-client-types/static-1.4209",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.845",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8039",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3811",
  "reporting-client-types": "/reporting-client-types/static-1.2568",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25711",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4990",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1175",
  "quartz-routing": "/quartz-routing/static-1.600",
  "hs-story-utils": "/hs-story-utils/static-1.9534",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.336",
  "timezone-utils": "/timezone-utils/static-2.5355",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4419",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2189",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.844",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.543",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.845",
  "quartz-tracking": "/quartz-tracking/static-1.549",
  "trellis-components": "/trellis-components/static-1.2208",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.178",
  "chirp-fetch": "/chirp-fetch/static-1.1998",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6085",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4162",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3025",
  "stylex": "/stylex/static-1.35",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1161",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.284",
  "pulse": "/pulse/static-1.709",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3877",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4218",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.123",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3771",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18725",
  "growth-data-modal": "/growth-data-modal/static-1.5606",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3177",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2242",
  "navigation-components": "/navigation-components/static-1.18288",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5026",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.878",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10350",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7731",
  "ui-universal-auth": "/ui-universal-auth/static-1.9111",
  "user-context": "/user-context/static-1.5222",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10239",
  "magpie-lib": "/magpie-lib/static-1.5625",
  "navigation-messaging": "/navigation-messaging/static-1.7615",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21831",
  "copilot-toolkit": "/copilot-toolkit/static-1.11426",
  "cms-field-types": "/cms-field-types/static-1.4927",
  "content-icons-ui": "/content-icons-ui/static-1.2257",
  "integrations-lib": "/integrations-lib/static-1.16512",
  "calling-global-api": "/calling-global-api/static-1.64900",
  "calling-internal-common": "/calling-internal-common/static-1.31421",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66282",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58576",
  "commerce-products-lib": "/commerce-products-lib/static-1.9964",
  "crm-links": "/crm-links/static-1.6420",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9568",
  "file-manager-components": "/file-manager-components/static-1.23931",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4298",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.745",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49133",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4048",
  "property-value-citations": "/property-value-citations/static-1.2581",
  "smart-property-lib": "/smart-property-lib/static-1.7788",
  "tiered-pricing": "/tiered-pricing/static-1.1509",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9179",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20025",
  "tinymce-themes": "/tinymce-themes/static-1.56635",
  "data-token-picker": "/data-token-picker/static-1.16604",
  "hub-http-contrib": "/hub-http-contrib/static-1.3155",
  "interframe": "/interframe/static-3.4872",
  "tinymce-data": "/tinymce-data/static-1.40750",
  "tinymce-plugins": "/tinymce-plugins/static-1.57779",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5321",
  "onboarding-scopes": "/onboarding-scopes/static-1.6573",
  "ui-addon-opt": "/ui-addon-opt/static-4.8473",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4763",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.449",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.285",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1053",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6088",
  "event-emitter": "/event-emitter/static-1.1061",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.212",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2152",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2270",
  "user-context-client": "/user-context-client/static-1.4692",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5085",
  "nest": "/nest/static-1.344",
  "reactive-lib": "/reactive-lib/static-1.837",
  "simple-logging-lib": "/simple-logging-lib/static-1.3161",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.907",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17843",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1109",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13927",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5718",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7895",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10474",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.625",
  "calling-error-reporting": "/calling-error-reporting/static-1.31428",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11147",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6655",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1431",
  "customer-data-tracking": "/customer-data-tracking/static-1.7000",
  "commerce-permissions": "/commerce-permissions/static-1.888",
  "products-iframe-lib": "/products-iframe-lib/static-1.8242",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10623",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9592",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4262",
  "video-components-external": "/video-components-external/static-1.11641",
  "video-data-lib": "/video-data-lib/static-1.35299",
  "data-agent-kit": "/data-agent-kit/static-1.379",
  "feedback-loader": "/feedback-loader/static-1.29507",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10324",
  "fsm": "/fsm/static-1.3840",
  "policy-lib": "/policy-lib/static-1.6893",
  "react-colorpicker": "/react-colorpicker/static-2.10319",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10387",
  "FileManagerLib": "/FileManagerLib/static-1.39571",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9136",
  "FileManagerCore": "/FileManagerCore/static-1.39430",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7930",
  "layout-dnd-components": "/layout-dnd-components/static-1.12662",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11637",
  "react-codemirror": "/react-codemirror/static-1.10739",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9998",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15685",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15107",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7717",
  "breeze-engine-core": "/breeze-engine-core/static-1.387",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3129",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.7",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.361",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.570",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.701",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.27",
  "slack-ui-library": "/slack-ui-library/static-1.10506",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36208",
  "sales-views-client-types": "/sales-views-client-types/static-1.4368",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12658",
  "content-media-compositions": "/content-media-compositions/static-2.16665",
  "media-bridge-lib": "/media-bridge-lib/static-1.19120",
  "trellis-story-utils": "/trellis-story-utils/static-1.4624",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6088",
  "FileManagerImages": "/FileManagerImages/static-1.37082",
  "video-components": "/video-components/static-1.13643",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4647",
  "video-embed": "/video-embed/static-1.36133",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8815",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28873",
  "ContentData": "/ContentData/static-1.68762",
  "layout-data-lib": "/layout-data-lib/static-1.9962",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22325",
  "outpost": "/outpost/static-1.4282",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6691",
  "advanced-menus-core": "/advanced-menus-core/static-1.15312",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12225",
  "ExportDialog": "/ExportDialog/static-6.10491",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34343",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15311",
  "simple-menus-lib": "/simple-menus-lib/static-1.16828"
}
};
